'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http, $state, $scope) {
    this.$http = $http;
    this.$state = $state;
    this.$scope = $scope;

    this.category = '全部';
  }

  $onInit() {

    this.$scope.$watch('asListCtrl.category', (c) => {
      if (c !== undefined && c !== null) {
        this.getApps(c);
      }
    });

    this.getCategories();
  }

  getApps(c) {
    let params = {
      all: 1
    };
    if (c && c != '全部') {
      params.category = c;
    }
    this.$http.get('/api/apks', {params: params}).then(response => {
      this.apps = response.data;
    });
  }

  deleteApp(id) {
    if (confirm("确定？")) {
      this.$http.delete('api/apks/' + id).then(response => {
        this.getApps(this.category);
      });
    }
  }

  getCategories() {
    this.$http.get('/api/categories/app').then(res => {
      this.categories = res.data.children;
    })
  }

}



// WEBPACK FOOTER //
// ./client/app/appstore/list/list.controller.js